import { Menu } from 'components/Menu';
import { MenuItem } from 'components/Menu/MenuItem';
import { TabPanel, Tabs } from 'components/Tabs';
import { AddUserIcon } from 'components/icons/AddUserIcon';
import { CloseIcon } from 'components/icons/CloseIcon';
import { SearchIcon } from 'components/icons/SearchIcon';
import { VerticalEllipsisIcon } from 'components/icons/VerticalEllipsisIcon';
import { useContext, useEffect, useState } from 'react';
import api from 'services/api';
import { v4 as uuid } from 'uuid';
import { MODAL_ANIMATIONS, MODAL_TYPES } from '../constants';
import { ModalContext } from 'context/ModalContext';
import CustomizedHook from 'components/CustomAutocomplete';
import clsx from 'clsx';

import { useSelector } from 'react-redux';
import { RootState } from 'store';

interface AddPeopleProps {
  onCancel: () => void;
  selectedChannel: any;
  workspaceMembers: any[];
  channelMembers: any[];
  tab: string;
}

export default function AddPeople({
  onCancel,
  selectedChannel,
  workspaceMembers,
  channelMembers,
  tab
}: AddPeopleProps) {
  const [peopleToBeAdded, setPeopleToBeAdded] = useState([]);
  const { showModal } = useContext(ModalContext);
  const workspaceUsers = useSelector((state: RootState) => state.members.users);
  const addPeople = () => {
    api
      .post(`/api/users/channel/${selectedChannel.hash_id}/invite-member/`, {
        users: peopleToBeAdded
      })
      .then(() => {
        showModal(MODAL_TYPES.channel_members, {
          animation: MODAL_ANIMATIONS.fade,
          selectedChannel,
          tab
        });
      });
  };

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:min-h-[200px]">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Add people to # {selectedChannel.name}</span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={() =>
              showModal(MODAL_TYPES.channel_members, {
                animation: MODAL_ANIMATIONS.fade,
                selectedChannel,
                tab
              })
            }
          />
        </div>
        <div className="px-7 mt-5">
          <CustomizedHook
            setPeopleToBeAdded={setPeopleToBeAdded}
            workspaceMembers={workspaceUsers}
            channelMembers={channelMembers}
          />
          <div
            className={clsx(
              'w-40 h-11 rounded-[10px] text-base font-bold flex items-center justify-center ml-auto mt-5',
              {
                'bg-green-600 text-white cursor-pointer': peopleToBeAdded.length > 0,
                'bg-buttonDisabledBg text-white pointer-events-none': peopleToBeAdded.length === 0
              }
            )}
            onClick={addPeople}
          >
            Add
          </div>
        </div>
      </div>
    </div>
  );
}
